<template>
  <footer class="c-footer">
    <div class="c-footer__container hide-on-pad-flex c-layout">
      <div class="c-footer__item">
        <div class="title">ABOUT US</div>
        <div class="line"></div>
        <div>{{ $t('footer.about_1') }}</div>
        <div>{{ $t('footer.about_2') }}</div>
        <div>{{ $t('footer.about_3') }}</div>
        <div>{{ $t('footer.about_4') }}</div>
      </div>
      <div class="c-footer__item">
        <div class="title">ORDER</div>
        <div class="line"></div>
        <div>{{ $t('footer.order_1') }}</div>
        <div>{{ $t('footer.order_2') }}</div>
        <div>{{ $t('footer.order_3') }}</div>
      </div>
      <div class="c-footer__item">
        <div class="title">MEMBER</div>
        <div class="line"></div>
        <div>{{ $t('footer.member_1') }}</div>
        <div>{{ $t('footer.member_2') }}</div>
        <div>{{ $t('footer.member_3') }}</div>
        <div>{{ $t('footer.member_4') }}</div>
      </div>
      <div class="c-footer__item">
        <div class="title">CUSTOMER SERVICE</div>
        <div class="line"></div>
        <div class="text" v-html="$t('footer.service_1')"></div>
        <div class="text">{{ $t('footer.service_2') }}</div>
        <div class="text">{{ $t('footer.service_3') }}</div>
        <div class="text"><a href="https://beian.miit.gov.cn/" target="_blank">{{ $t('footer.gov_no') }}</a></div>
      </div>
      <div class="footer-icon">
        <div class="footer-icon__item footer-icon__1"></div>
        <div class="footer-icon__item footer-icon__2"></div>
      </div>
    </div>
    <div class="c-footer__container show-on-pad-flex">
      <div class="online-service">
        <div class="service-icon"></div>{{ $t('footer.service') }}
      </div>
      <div class="info">
        <p v-html="$t('footer.mobile_service_1')"></p>
        <p>{{ $t('footer.mobile_service_2') }}</p>
        <p>{{ $t('footer.mobile_service_3') }}</p>
        <p>{{ $t('footer.mobile_service_4') }}</p>
        
        
      </div>
      <div class="item-block">
        <div class="c-footer__item">
          <div class="title" @click="handleOpenItem">{{ $t('footer.about_title') }}</div>
          <div class="line"></div>
          <div class="item-content-list">
            <div class="content-item">{{ $t('footer.about_1') }}</div>
            <div class="content-item">{{ $t('footer.about_2') }}</div>
            <div class="content-item">{{ $t('footer.about_3') }}</div>
            <div class="content-item">{{ $t('footer.about_4') }}</div>
          </div>
        </div>
        <div class="c-footer__item">
          <div class="title" @click="handleOpenItem">{{ $t('footer.order_title') }}</div>
          <div class="line"></div>
          <div class="item-content-list">
            <div class="content-item">{{ $t('footer.order_1') }}</div>
            <div class="content-item">{{ $t('footer.order_2') }}</div>
            <div class="content-item">{{ $t('footer.order_3') }}</div>
          </div>
        </div>
        <div class="c-footer__item">
          <div class="title" @click="handleOpenItem">{{ $t('footer.member_title') }}</div>
          <div class="line"></div>
          <div class="item-content-list">
            <div class="content-item">{{ $t('footer.member_1') }}</div>
            <div class="content-item">{{ $t('footer.member_2') }}</div>
            <div class="content-item">{{ $t('footer.member_3') }}</div>
            <div class="content-item">{{ $t('footer.member_4') }}</div>
          </div>
        </div>
        <div class="c-footer__item">
          <div class="title" @click="handleOpenItem">{{ $t('footer.qa_title') }}</div>
          <div class="line"></div>
          <div class="item-content-list">
            <div  class="content-item" v-html="$t('footer.qa_1')"></div>
            <div  class="content-item">{{ $t('footer.qa_2') }}</div>
            <div  class="content-item">{{ $t('footer.qa_3') }}</div>
          </div>
        </div>
      </div>
      <div class="social-media">
        <Icon type="wechat"></Icon>
        <Icon type="weibo"></Icon>
      </div>
      <p class="copyright" v-html="$t('footer.copyright')"></p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleOpenItem(e) {
      e.target.classList.toggle('open');
    }
  },
  components: {},
};
</script>

<style scoped lang='less'>
.c-footer {
  height: 318px;
  background: url("./images/footer.png") no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  @media (max-width: 992px) {
    height: auto;
  }
  .c-footer__container {
    position: relative;
    display: flex;
    padding-top: 60px;
    @media (max-width: 992px) {
      padding: 24px 19px 76px 19px;
      flex-direction: column;
    }
  }
  .c-footer__item > div {
    padding: 10px 0;
  }
  .c-footer__item:last-child > .text {
    padding: 5px 0;
  }
  .c-footer__item:last-child > .line {
    margin-bottom: 5px;
  }
  .c-footer__item {
    margin-right: 105px;
    font-size: 13px;
    color: var(--unnamed-color-ffffff);
    text-shadow: 0px 3px 3px var(--unnamed-color-000000);
    color: #ffffff;
    text-shadow: 0px 3px 3px #000000;
    opacity: 1;
    @media (max-width: 992px) {
      margin-right: 0;
      margin-bottom: 20px;
    }
    .line {
      min-width: 120px;
      padding: 0;
      height: 0.2958984375px;
      box-shadow: 0px 3px 6px var(--unnamed-color-000000);
      border-bottom: 1px solid var(--unnamed-color-ffffff);
      box-shadow: 0px 3px 6px #000000;
      opacity: 1;
      position: relative;
      @media (max-width: 992px) {
        &::after {
          content: '';
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:none;%7D.b%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M24,0H0V24H24Z'/%3E%3Cpath class='b' d='M8,7.351,9.351,6l5.75,5.75L9.351,17.5,8,16.149l4.389-4.4Z' transform='translate(0.75 0.25)'/%3E%3C/svg%3E");
          width: 32px;
          height: 32px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }

    .title {
      font-size: 16px;
      letter-spacing: var(--unnamed-character-spacing-0);
      color: var(--unnamed-color-ffffff);
      text-shadow: 0px 3px 6px var(--unnamed-color-000000);
      text-align: left;
      font: Regular 16px/16px Noto Sans SC;
      color: #ffffff;
      text-shadow: 0px 3px 6px #000000;
      opacity: 1;
      @media (max-width: 992px) {
        &.open~.item-content-list {
          height: auto;
          padding: 20px;
        }
      }
    }

    .item-content-list {
      padding: 20px;
      padding-bottom: 0;
      height: 0;
      overflow: hidden;
      padding: 0;
      .content-item {
        text-shadow: 0px 3px 6px var(--unnamed-color-000000);
        margin-bottom: 10px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
  .footer-icon {
    position: absolute;
    right: -10px;
    top: 90px;
    .footer-icon__item {
      width: 55px;
      height: 55px;
      margin-bottom: 14px;
    }
    .footer-icon__1 {
      background: url("./images/64 – 1@2x.png") no-repeat;
      background-size: contain;
      background-position: center center;
    }
    .footer-icon__2 {
      background: url("./images/63 – 1@2x.png") no-repeat;
      background-size: contain;
      background-position: center center;
    }
  }

  .online-service {
    background: white;
    padding: 10px;
    color: var(---unnamed-color-ec4f00);
    display: flex;
    flex-direction: row;
    line-height: 30px;
    justify-content: center;
    .service-icon {
      width: 30px;
      height: 30px;
      background-image: url('./images/forum-24px@3x.png');
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: 10px;
    }
  }
  .info {
    color: white;
    padding: 20px;
    padding-bottom: 10px;
    p {
      font-size: 13px;
      letter-spacing: var(--unnamed-character-spacing-0);
      color: var(--unnamed-color-ffffff);
      text-shadow: 0px 3px 6px var(--unnamed-color-000000);
      text-align: left;
      color: #ffffff;
      opacity: 1;
      margin-bottom: 10px;
    }
  }
  .social-media {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    & /deep/ .cloud-icon {
      margin-right: 20px;
      fill: white;
      width: 30px;
      height: 30px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }
  .copyright {
    text-shadow: 0px 3px 3px var(--unnamed-color-000000);
    color: white;
    font-size: 13px;
    text-align: center;
  }
}
</style>
